export const redColor = '#ef4a3d'
export const blackColor = '#B0B0AD'

const compareParts = []

export default compareParts
